import React from "react";
import { useNavigate } from "react-router-dom";
import { FaBookOpen, FaAward, FaUserGraduate, FaHome, FaUserCheck, FaCalendarCheck, FaSnowflake } from "react-icons/fa";
import "../css/KirnavaliCrestest.css";

// Import your background banner and section image (adjust paths as needed)
import kirnavaliBg from "../../images/Banner3.png";
import kirnavaliMainImg from "../../images/logo.png";

function KirnavaliCrestest() {
    const navigate = useNavigate();

    return (
        <section className="kirnavali-section" style={{ backgroundImage: `url(${kirnavaliBg})` }}>
            <div className="container kirnavali-container-box">
                <div className="row align-items-center g-5">

                    {/* Left Column: Full Width Image */}
                    <div className="col-lg-6">
                        <div className="kirnavali-image-wrapper">
                            <img
                                src={kirnavaliMainImg}
                                alt="Kirnavali Feature"
                                className="kirnavali-main-image img-fluid"
                            />
                        </div>
                    </div>

                    {/* Right Column: Content Pointers & Action Button */}
                    <div className="col-lg-6">
                        <div className="kirnavali-content-wrapper">

                            <span className="kirnavali-mini-tag">
                                ABOUT FIXOVERA
                            </span>

                            <h2 className="kirnavali-main-heading">
                                Fixovera – Your Trusted AC & Home Appliance Service Partner
                            </h2>

                            <div className="kirnavali-zigzag-border mb-4"></div>


                            {/* Pointer Items */}
                            <div className="kirnavali-pointers-list">


                                {/* Pointer 1 */}
                                <div className="kirnavali-pointer-item">

                                    <div className="kirnavali-icon-box">
                                        <FaSnowflake />
                                    </div>

                                    <div className="kirnavali-text-block">

                                        <span className="kirnavali-small-tag">
                                            AC & Home Appliance Services
                                        </span>

                                        <h4>
                                            Complete Appliance Care For Your Home
                                        </h4>

                                        <p>
                                            Access reliable AC and home appliance services in one place,
                                            including AC servicing and repair, refrigerator, washing
                                            machine, microwave, oven, TV, and other essential appliance
                                            maintenance services.
                                        </p>

                                    </div>

                                </div>


                                {/* Pointer 2 */}
                                <div className="kirnavali-pointer-item">

                                    <div className="kirnavali-icon-box">
                                        <FaUserCheck />
                                    </div>

                                    <div className="kirnavali-text-block">

                                        <span className="kirnavali-small-tag">
                                            Skilled Appliance Professionals
                                        </span>

                                        <h4>
                                            Connect With Trusted Service Experts
                                        </h4>

                                        <p>
                                            Fixovera connects customers with skilled professionals
                                            specializing in AC and home appliance repair, servicing,
                                            installation, troubleshooting, and maintenance with
                                            convenience and care.
                                        </p>

                                    </div>

                                </div>


                                {/* Pointer 3 */}
                                <div className="kirnavali-pointer-item">

                                    <div className="kirnavali-icon-box">
                                        <FaCalendarCheck />
                                    </div>

                                    <div className="kirnavali-text-block">

                                        <span className="kirnavali-small-tag">
                                            Simple Appliance Service Experience
                                        </span>

                                        <h4>
                                            Book, Manage & Track With Ease
                                        </h4>

                                        <p>
                                            From selecting the right AC or appliance service to
                                            scheduling a booking and managing your service journey,
                                            Fixovera makes appliance maintenance simple, convenient,
                                            and organized.
                                        </p>

                                    </div>

                                </div>


                            </div>


                        </div>



                    </div>


                </div>
            </div>
        </section>
    );
}

export default KirnavaliCrestest;